export function getHeroContent() {
  return {
    title: "TAILORED FOR YOU",
    description:
      "Your goals shape our solutions. At Tenth Corporation, we turn your challenges into opportunities and your ideas into action. Every success you achieve is a win we celebrate together.",
    backgroundImage: "/assets/images/contactus.jpg",
  };
}

export const getFooterContent = () => ({
  backgroundColor: "#96B596",
  text: "© 2025 Tenth Corporation Inc. All Rights Reserved",
});


export const getProductOptions = () => ([
  "Human Resource Information System",
  "Document Management System",
  "Barangay Information System"
]);

export const getContactDetails = () => ({
  location: "...",
  phone: "...",
  email: "...",
});

